import { formatDecimal, formatNumber, formatPercent } from '../Number';

import React from 'react';
import { getLocaleCode } from '../../state/locale/Locale.selectors';
import useBoundCallback from '/b2b/common/helpers/Hooks/useBoundCallback';
import { useSelector } from 'react-redux';

function localizedNumber(localeCode, value) {
    return formatNumber(value, localeCode);
}

function localizedPercent(localeCode, value, decimalPlaces) {
    return formatPercent(value, localeCode, decimalPlaces);
}

function localizedDecimal(localeCode, value, decimalPlaces) {
    return formatDecimal(value, localeCode, decimalPlaces);
}

export function useFormatNumber() {
    const localeCode = useSelector(getLocaleCode);

    const fmtNumber = useBoundCallback(localizedNumber, [localeCode]);
    const fmtPercent = useBoundCallback(localizedPercent, [localeCode]);
    const fmtDecimal = useBoundCallback(localizedDecimal, [localeCode]);

    const memoHelpers = React.useMemo(
        () => ({
            formatNumber: fmtNumber,
            formatPercent: fmtPercent,
            formatDecimal: fmtDecimal,
            localeCode,
        }),
        [localeCode]
    );

    return memoHelpers;
}

export default useFormatNumber;
